import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AboutPage: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />
      
      {/* Spațiu pentru header-ul fix */}
      <div className="pt-24 md:pt-28"></div>
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-600 to-blue-800 text-white py-20 relative overflow-hidden">
          {/* Background decorations */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-white"></div>
            <div className="absolute top-1/4 left-1/4 w-48 h-48 rounded-full bg-white"></div>
            <div className="absolute bottom-12 right-1/3 w-64 h-64 rounded-full bg-white"></div>
          </div>
          
          <div className="container mx-auto px-4 relative z-10">
            <div className="text-center">
              <div className="text-6xl mb-6">📚</div>
              <h1 className="text-4xl md:text-5xl font-bold mb-6">Despre Biblioteca Noastră Digitală</h1>
              <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-8">
                Un ecosistem online dedicat diseminării cunoștințelor și culturii prin acces liber și sustenabil
              </p>
              
              {/* Action buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link 
                  to="/help" 
                  className="px-8 py-4 bg-white text-blue-700 font-bold rounded-xl hover:bg-blue-50 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                >
                  <span className="flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Centrul de Ajutor
                  </span>
                </Link>
                <Link 
                  to="/copyright" 
                  className="px-8 py-4 bg-yellow-400 text-blue-900 font-bold rounded-xl hover:bg-yellow-300 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                >
                  <span className="flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                    Protecția Drepturilor
                  </span>
                </Link>
              </div>
            </div>
          </div>
          
          {/* Wave divider */}
          <div className="absolute bottom-0 left-0 right-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 180">
              <path fill="#F9FAFB" fillOpacity="1" d="M0,96L60,106.7C120,117,240,139,360,138.7C480,139,600,117,720,101.3C840,85,960,75,1080,80C1200,85,1320,107,1380,117.3L1440,128L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path>
            </svg>
          </div>
        </section>

        {/* Statistici impressive */}
        <section className="py-16 -mt-16 relative z-10">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div className="bg-white p-6 rounded-xl shadow-lg text-center border-l-4 border-blue-600">
                <div className="text-3xl font-bold text-blue-600 mb-2">10,000+</div>
                <div className="text-gray-600">Cărți disponibile</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-lg text-center border-l-4 border-green-600">
                <div className="text-3xl font-bold text-green-600 mb-2">5,000+</div>
                <div className="text-gray-600">Utilizatori activi</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-lg text-center border-l-4 border-purple-600">
                <div className="text-3xl font-bold text-purple-600 mb-2">500+</div>
                <div className="text-gray-600">Manuscrise rare</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-lg text-center border-l-4 border-orange-600">
                <div className="text-3xl font-bold text-orange-600 mb-2">24/7</div>
                <div className="text-gray-600">Acces disponibil</div>
              </div>
            </div>
          </div>
        </section>

        {/* Misiunea noastră */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-bold text-gray-800 mb-6 flex items-center">
                  <span className="w-10 h-10 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mr-4">
                    🎯
                  </span>
                  Misiunea Noastră
                </h2>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Biblioteca Digitală își propune să democratizeze accesul la cunoaștere prin oferirea unei platforme moderne, 
                  accesibile și comprehensive pentru toate tipurile de resurse educaționale și culturale.
                </p>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Credem că educația și cultura trebuie să fie disponibile pentru toți, indiferent de locație sau circumstanțe. 
                  Prin tehnologia noastră avansată, facilitam accesul la mii de cărți, documente istorice și resurse academice.
                </p>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                  <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700">Acces gratuit la resurse</span>
                  </div>
                  <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700">Platformă multilingvă</span>
                  </div>
                  <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700">Tehnologie modernă</span>
                  </div>
                  <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-700">Conservare digitală</span>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4">
                  <Link 
                    to="/books" 
                    className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition flex items-center justify-center"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                    </svg>
                    Explorează Colecția
                  </Link>
                  <Link 
                    to="/help" 
                    className="px-6 py-3 border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50 transition flex items-center justify-center"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Învață să folosești
                  </Link>
                </div>
              </div>
              <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-8 rounded-2xl">
                <div className="text-center">
                  <div className="text-blue-600 text-6xl mb-4">📚</div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">Peste 10,000 Resurse</h3>
                  <p className="text-gray-600 mb-6">
                    Cărți, manuscrise, documente istorice și resurse academice disponibile pentru toți utilizatorii
                  </p>
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div className="bg-white p-3 rounded-lg">
                      <div className="font-bold text-blue-600">Fiction</div>
                      <div className="text-gray-600">3,500 cărți</div>
                    </div>
                    <div className="bg-white p-3 rounded-lg">
                      <div className="font-bold text-green-600">Non-Fiction</div>
                      <div className="text-gray-600">2,800 cărți</div>
                    </div>
                    <div className="bg-white p-3 rounded-lg">
                      <div className="font-bold text-purple-600">Academice</div>
                      <div className="text-gray-600">2,200 resurse</div>
                    </div>
                    <div className="bg-white p-3 rounded-lg">
                      <div className="font-bold text-orange-600">Rare</div>
                      <div className="text-gray-600">1,500 manuscrise</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Valorile noastre */}
        <section className="py-16 bg-gray-100">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-800 mb-4">Valorile Noastre</h2>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Principiile fundamentale care ne ghidează în misiunea de a face cunoașterea accesibilă tuturor
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 text-center group">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                  <div className="text-blue-600 text-2xl">🌍</div>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-4">Accesibilitate</h3>
                <p className="text-gray-600 leading-relaxed">
                  Oferim acces egal la educație și cultură pentru toate comunitățile, eliminând barierele geografice și economice.
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 text-center group">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                  <div className="text-green-600 text-2xl">🔍</div>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-4">Calitate</h3>
                <p className="text-gray-600 leading-relaxed">
                  Curăm și digitizăm cu atenție fiecare resursă pentru a asigura cea mai bună experiență de lectură și cercetare.
                </p>
              </div>
              <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 text-center group">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                  <div className="text-purple-600 text-2xl">🤝</div>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-4">Colaborare</h3>
                <p className="text-gray-600 leading-relaxed">
                  Lucrăm cu biblioteci, universități și instituții culturale pentru a îmbogăți continuu colecția noastră.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Tehnologia noastră */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1">
                <div className="bg-gradient-to-br from-indigo-50 to-blue-50 p-8 rounded-2xl">
                  <div className="grid grid-cols-2 gap-6">
                    <div className="text-center">
                      <div className="text-3xl mb-2">⚡</div>
                      <div className="font-bold text-gray-800">Căutare Rapidă</div>
                      <div className="text-sm text-gray-600">Algoritmi avansați</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl mb-2">📱</div>
                      <div className="font-bold text-gray-800">Responsive</div>
                      <div className="text-sm text-gray-600">Toate dispozitivele</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl mb-2">🔒</div>
                      <div className="font-bold text-gray-800">Securitate</div>
                      <div className="text-sm text-gray-600">Protecție avansată</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl mb-2">☁️</div>
                      <div className="font-bold text-gray-800">Cloud Storage</div>
                      <div className="text-sm text-gray-600">Backup automat</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="order-1 lg:order-2">
                <h2 className="text-3xl font-bold text-gray-800 mb-6">Tehnologia Din Spatele Platformei</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Folosim cele mai moderne tehnologii pentru a oferi o experiență de utilizare superioară. 
                  Platforma noastră este construită cu focus pe performanță, securitate și accesibilitate.
                </p>
                <div className="space-y-4 mb-6">
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Interfață intuitivă și user-friendly</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Căutare semantică avansată</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Recomandări personalizate</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Sincronizare între dispozitive</span>
                  </div>
                </div>
                <Link 
                  to="/help" 
                  className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
                >
                  Află cum să folosești platforma
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Call to action section */}
        <section className="py-16 bg-gradient-to-r from-blue-600 to-purple-700 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-6">Începe Călătoria Ta în Lumea Cunoașterii</h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Alătură-te miilor de utilizatori care descoperă zilnic noi cunoștințe prin biblioteca noastră digitală
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/books" 
                className="px-8 py-4 bg-white text-blue-700 font-bold rounded-xl hover:bg-blue-50 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                Explorează Cărțile
              </Link>
              <Link 
                to="/help" 
                className="px-8 py-4 bg-transparent border-2 border-white text-white font-bold rounded-xl hover:bg-white hover:text-blue-700 transition-all duration-300"
              >
                Ghid de Utilizare
              </Link>
              <Link 
                to="/copyright" 
                className="px-8 py-4 bg-yellow-400 text-blue-900 font-bold rounded-xl hover:bg-yellow-300 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                Politici și Drepturi
              </Link>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default AboutPage; 